/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".shopping-list-wrapper[_ngcontent-%COMP%]{height:100%}.modal-body[_ngcontent-%COMP%]{height:464px;overflow:auto}.info-section[_ngcontent-%COMP%]{padding:0 18px}.info-section[_ngcontent-%COMP%]   .font-weight-bold[_ngcontent-%COMP%]{font-size:.975rem;text-transform:uppercase}.info-section[_ngcontent-%COMP%]   .info-text[_ngcontent-%COMP%]{margin-top:-10px;color:#6b6b6b;text-transform:uppercase;font-size:.74rem}.shopping-email[_ngcontent-%COMP%]{margin-top:15px}"];
export { styles as styles };
